import React from "react";

// Components
import { ProvideExternalInfo } from "@secondcloset/web-components";

// Hooks
import useOrderCreateFlow from "../../../../hooks/reduxContainer/fulfillment/orderCreateFlow";

const ProvideExternalInfoStep = () => {
  const {
    externalOrderNumber,
    notes,
    insuranceValue,
    files,
    dispatchIExternalOrderNumber,
    dispatchSetNotes,
    dispatchSetInsuranceValue,
    dispatchAddFile,
    dispatchRemoveFile,
  } = useOrderCreateFlow();

  return (
    <ProvideExternalInfo
      externalOrderNumber={externalOrderNumber}
      insuranceValue={insuranceValue}
      notes={notes}
      files={files}
      onExternalOrderNumberChange={(v) => dispatchIExternalOrderNumber(v)}
      onInsuranceValueChange={(v) => dispatchSetInsuranceValue(v)}
      onNotesChange={(v) => dispatchSetNotes(v)}
      onAddNewFile={dispatchAddFile}
      onRemoveFile={(file) => dispatchRemoveFile(file.uid)}
    />
  );
};

export default ProvideExternalInfoStep;
